import { Box } from '@mui/material';

const EMPTY_SX = {
  borderRadius: 2,
  backgroundColor: 'var(--mui-palette-background-brandSubtle)',
  px: 2,
  py: 2,
  color: 'text.secondary',
  fontSize: 14,
  lineHeight: 1.4,
} as const;

const EmptyInterruptionList = () => <Box sx={EMPTY_SX}>No interruptions</Box>;

export default EmptyInterruptionList;
